import type { ReactNode } from "react";

export function QuotesColumnSectionHeader({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <div className="mt-4 text-[14px] font-semibold text-foreground">
      {children}
    </div>
  );
}
